import clsx from 'clsx'
import React, {FC, useEffect, useRef, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu} from '../../../partials'
import {UserInterface} from '../../../../app/modules/auth/models/UserModel'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {useNotifications, useProducts} from '../../../../app/@contexts'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'svg-icon-1'
const TopBar: FC = () => {

  const {products: {sav}} = useProducts()
  const isAuthorizedSAV = !!sav.activated_at

  const {
    images,
    firstname,
    lastname,
  }: UserInterface = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserInterface
  const image = images.length ? images[0].path : toAbsoluteUrl('/media/avatars/blank.png')

  const {userNotifications: {count}} = useNotifications()

  const toggleRef = useRef<HTMLDivElement | null>(null)
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)

  useEffect(() => {
    const element = toggleRef.current;

    if (element) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "attributes" && mutation.attributeName === "class") {
            const hasShowClass = element.classList.contains("show");
            setIsMenuOpen(hasShowClass);
          }
        });
      });

      observer.observe(element, { attributes: true });

      return () => {
        observer.disconnect();
      };
    }
  }, []);

  return (
    <div className="d-flex align-items-stretch flex-shrink-0">

      {/* NOTIFICATIONS */}
      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        {/* begin::Menu- wrapper */}
        <div
          className={clsx(
            'btn btn-icon btn-active-light-primary position-relative',
            toolbarButtonHeightClass,
          )}
          data-kt-menu-trigger="click"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-end"
          data-kt-menu-flip="bottom"
        >
          <KTSVG
            path="/media/icons/duotune/general/gen007.svg"
            className={toolbarButtonIconSizeClass}
          />



          {
            isAuthorizedSAV && count
              ? <span
                className="badge badge-circle fs-7 p-2 bg-light-danger text-danger position-absolute translate-middle top-0 start-75 animation-blink">{count}</span>
              : <></>
          }

        </div>
        <HeaderNotificationsMenu />
        {/* end::Menu wrapper */}
      </div>

      {/* begin::User */}
      <div
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        id="kt_header_user_menu_toggle"
      >
        {/* begin::Toggle */}
        <div
          ref={toggleRef}
          className={clsx(
            'cursor-pointer symbol d-flex align-items-center',
            toolbarUserAvatarHeightClass,
            {'show menu-dropdown': isMenuOpen},
          )}
          data-kt-menu-trigger="click"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-end"
          data-kt-menu-flip="bottom"
        >
          <div className="d-flex flex-column justify-content-between align-items-end px-2">
            <span
              className="cursor-pointer text-gray-600 text-hover-primary fs-7 fs-sm-6 text-capitalize">
                {firstname} {lastname}
            </span>
            <span style={{fontFamily: "inherit", transform: `rotate(${isMenuOpen ? 180 : 0}deg)`, transition: "all .15s ease-in-out",}}>
                <KTSVG path="/media/icons/duotune/arrows/arr072.svg" className="svg-icon svg-icon svg-icon-2" />
            </span>
          </div>
          <img alt="Logo" src={image} style={{objectFit: 'cover'}} />
        </div>
        <HeaderUserMenu />
        {/* end::Toggle */}
      </div>
      {/* end::User */}

      {/* begin::Aside Toggler */}
      {/*{config.header.left === 'menu' && (*/}
      {/*  <div className="d-flex align-items-center d-lg-none ms-2 me-n3" title="Show header menu">*/}
      {/*    <div*/}
      {/*      className="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px"*/}
      {/*      id="kt_header_menu_mobile_toggle"*/}
      {/*    >*/}
      {/*      <KTSVG path="/media/icons/duotune/text/txt001.svg" className="svg-icon-1" />*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*)}*/}
    </div>
  )
}

export {TopBar}